var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-card-layout"},[_c('div',{staticClass:"left"},[_vm._t("left")],2),_c('div',{staticClass:"center"},[_vm._t("center")],2),_c('div',{staticClass:"right"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }